const numerosCoberturasOpcionales = ["22", "35"];

const checkOptionalCoveragesSelected = (coberturas) => {
    for (const cobertura of coberturas) {
        if (numerosCoberturasOpcionales.includes(cobertura.numeroCobertura)) {
            if (cobertura.selectedCobertura) {
                return true;
            }
        }
    }
    return false;
}

export {numerosCoberturasOpcionales, checkOptionalCoveragesSelected}